import React from 'react';
import { Link } from 'react-router-dom';
import './ReferralConfirmation.css';

function ReferralConfirmation({ data }) {
  return (
    <div className="referral-confirmation">
      <div className="confirmation-icon">✅</div>
      <h2>Referral Request Submitted!</h2>
      <p>
        Your referral request for {data.company.name} has been submitted successfully.
        We'll send your information to our trusted contact at {data.company.name}.
      </p>
      <p className="next-steps">
        What happens next:
      </p>
      <ol>
        <li>Our trusted contact will review your information</li>
        <li>You'll receive an email confirmation when they submit the referral</li>
        <li>The company's recruiting team will reach out to you directly</li>
      </ol>
      <Link to="/" className="home-button">
        Return to Home
      </Link>
    </div>
  );
}

export default ReferralConfirmation; 